import Vue from 'vue'
import {login} from '@/api/auth'
import {
	TOKEN,
	USER_INFO,
	PERMISSIONS,
	ROLES
} from '@/store/storage-types'
import {generatorDynamicRouter} from '@/router/dynamicRouter'
import {constantRouters} from '@/router/constantRouter'

const user = {
	state: {
		token: '',
		roles: [],
		permissions: [],
		info: {},
		routers: constantRouters,
		userRouters: []
	},
	getters: {
		token: state => state.token,
		roles: state => state.roles,
		permissions: state => state.permissions,
		userInfo: state => state.info,
		userRouters: state => state.userRouters,
	},
	mutations: {
		SET_TOKEN: (state, token) => {
			state.token = token
		},
		SET_INFO: (state, userInfo) => {
			state.info = userInfo
		},
		SET_ROLES: (state, roles) => {
			state.roles = roles
		},
		SET_PERMISSIONS: (state, permissions) => {
			state.permissions = permissions
		},
		SET_ROUTERS: (state, routers) => {
			state.userRouters = routers
		}
	},

	actions: {
		// 登录
		Login({commit}, loginParam) {
			return new Promise((resolve, reject) => {
				login(loginParam).then(res => {
					const {result} = res
					const ttl = result.expireSec * 1000
					const token = result.token
					const userInfo = result.userInfo
					const permissons = result.userInfo.authorities
					const roles = result.userInfo.roles
					if (permissons.length < 0) {
						reject(new Error("用户无权限登录"))
					}
					Vue.ls.set(USER_INFO, userInfo, ttl)
					commit('SET_INFO', userInfo);
					Vue.ls.set(ROLES, roles, ttl)
					commit('SET_ROLES', roles)
					Vue.ls.set(PERMISSIONS, permissons, ttl)
					commit('SET_PERMISSIONS', permissons)
					Vue.ls.set(TOKEN, token, ttl)
					commit('SET_TOKEN', token)
					resolve()
				}).catch(error => reject(error))
			})
		},
		// 登出
		Logout({dispatch, commit, state}) {
			return new Promise((resolve) => {

				dispatch('CLEAN_USER_INFO').then(() => {
					setTimeout(() => {
						window.location.reload()
					}, 10)
				})

			})
		},

		CLEAN_USER_INFO ({ commit, state }) {
			return new Promise((resolve) => {
				commit('SET_TOKEN', '')
				commit('SET_ROLES', [])
				Vue.ls.remove(TOKEN)
				Vue.ls.remove(USER_INFO)
				Vue.ls.remove(PERMISSIONS)
				Vue.ls.remove(ROLES)
				resolve()
			})
		},

		GenerateRoutes({commit}) {
			return new Promise(resolve => {
				generatorDynamicRouter().then(routers => {
					commit('SET_ROUTERS', routers)
					resolve()
				})
			})
		}
	}
}

export default user
